import { putCoreSonarObjectsStakeholdersBulkSlice } from './put';

export const {
	requestPutCoreSonarObjectsStakeholdersBulk,
	resetPutCoreSonarObjectsStakeholdersBulk
} = putCoreSonarObjectsStakeholdersBulkSlice.asyncActionCreators;
